import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { DialogContent, DialogContentText } from "@material-ui/core";
import alertTriangle from "../../../assets/svgs/alert-triangle.svg";

interface ErrorModalProps {
  onClose: any;
  errorText: string | null;
}

const useStyles = makeStyles({
  dialog: {
    width: 400,
    background: "white",
    borderRadius: 0,
  },
  content: {
    color: "#00152E",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "lato",
    lineHeight: "normal",
    textAlign: "center",
  },
  icon: {
    filter: "invert(36%) sepia(96%) saturate(1083%) hue-rotate(331deg) brightness(101%) contrast(89%)",
  },
  iconContainer: {
    textAlign: "center",
    margin: "20px 0px",
  },
  onlyOneButtonStyle: {
    width: "100%",
  },
});

const ErrorModal: React.FC<ErrorModalProps> = ({ onClose, errorText }) => {
  const classes = useStyles();

  return (
    <Dialog open={true} onClose={onClose} PaperProps={{ className: classes.dialog }}>
      <DialogContent>
        <div className={classes.iconContainer}>
          <img src={alertTriangle} width="30" height="30" className={classes.icon} />
        </div>
        <DialogContentText>
          <div className={classes.content}>{errorText}</div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" className={classes.onlyOneButtonStyle}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ErrorModal;
